import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { GitlabClient } from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

/**
 * Finishes multi-group onboarding (B-v1a): creates one installation per group
 * from the post-OAuth session and returns the per-group results. The BE
 * dispatches the per-group webhook install asynchronously, so this resolves
 * quickly with the created/failed counts.
 */
export const useProvisionGroupsMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.provision-groups');

  return useMutation({
    mutationKey: [MUTATION_KEYS.PROVISION_GITLAB_GROUPS],
    mutationFn: () => GitlabClient.provisionGroups(),
    onError: (err: unknown) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
